import React, { useState, useEffect } from 'react';
import { Layout, Badge, Avatar, Dropdown, Space, Drawer, Menu, Button } from 'antd';
import {
  BellOutlined,
  UserOutlined,
  MenuOutlined,
  DashboardOutlined,
  ShoppingOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { deliveryService } from '../../services/deliveryService';
import { useNavigate } from 'react-router-dom';
import PersistentLocationTracker from './PersistentLocationTracker';

const { Header: AntHeader } = Layout;

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  // Fetch unread notification count
  const fetchUnreadCount = async () => {
    try {
      const response = await deliveryService.getNotifications();
      if (response.data.success && Array.isArray(response.data.data)) {
        const unreadNotifications = response.data.data.filter((n) => !n.is_read);
        setUnreadCount(unreadNotifications.length);
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const mobileMenuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: '/orders', icon: <ShoppingOutlined />, label: 'Orders' },
    { key: '/earnings', icon: <DollarOutlined />, label: 'Earnings' },
    { key: '/location', icon: <EnvironmentOutlined />, label: 'Location' },
    { key: '/analytics', icon: <BarChartOutlined />, label: 'Analytics' },
    { key: '/profile', icon: <UserOutlined />, label: 'Profile' },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      label: 'Profile',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'notifications',
      label: 'Notifications',
      onClick: () => navigate('/notifications'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      onClick: logout,
    },
  ];

  return (
    <>
      <AntHeader
        style={{
          padding: '0 16px',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: '18px' }} />}
            onClick={() => setMobileDrawerOpen(true)}
            className="mobile-menu-btn"
          />
          <img
            src="/images/kankali-logo.png"
            alt="Kankali Mart"
            style={{ height: '36px', width: 'auto' }}
            onError={(e) => {
              e.target.src =
                'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect width=%22100%22 height=%22100%22 rx=%2220%22 fill=%22%232d5a3d%22/%3E%3Ctext x=%2250%22 y=%2268%22 font-family=%22Arial,sans-serif%22 font-size=%2244%22 font-weight=%22bold%22 fill=%22white%22 text-anchor=%22middle%22%3ECC%3C/text%3E%3C/svg%3E';
            }}
          />
        </div>

        <Space size="middle" className="header-actions">
          <PersistentLocationTracker isAuthenticated={true} />
          <Badge count={unreadCount} size="small" offset={[10, 0]}>
            <BellOutlined
              style={{ fontSize: '18px', color: '#666', cursor: 'pointer' }}
              onClick={() => navigate('/notifications')}
            />
          </Badge>

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" arrow>
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span className="user-name-desktop">{user?.full_name || user?.name || 'User'}</span>
            </Space>
          </Dropdown>
        </Space>
      </AntHeader>

      <Drawer
        title={
          <img
            src="/images/kankali-logo.png"
            alt="Kankali Mart"
            style={{ height: '36px', width: 'auto' }}
            onError={(e) => {
              e.target.src =
                'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect width=%22100%22 height=%22100%22 rx=%2220%22 fill=%22%232d5a3d%22/%3E%3Ctext x=%2250%22 y=%2268%22 font-family=%22Arial,sans-serif%22 font-size=%2244%22 font-weight=%22bold%22 fill=%22white%22 text-anchor=%22middle%22%3ECC%3C/text%3E%3C/svg%3E';
            }}
          />
        }
        placement="left"
        onClose={() => setMobileDrawerOpen(false)}
        open={mobileDrawerOpen}
        width={260}
      >
        <div
          style={{
            textAlign: 'center',
            padding: '24px 0',
            borderBottom: '1px solid #f0f0f0',
            marginBottom: 8,
          }}
        >
          <Avatar size={56} icon={<UserOutlined />} />
          <div style={{ marginTop: 8, fontWeight: 500 }}>
            {user?.full_name || user?.name || 'Delivery User'}
          </div>
          <div style={{ fontSize: 12, color: '#888' }}>Delivery Personnel</div>
        </div>
        <Menu
          mode="vertical"
          selectedKeys={[window.location.pathname]}
          items={mobileMenuItems}
          onClick={({ key }) => {
            navigate(key);
            setMobileDrawerOpen(false);
          }}
          style={{ borderRight: 0 }}
        />
      </Drawer>
    </>
  );
};

export default Header;
